import 'idempotent-babel-polyfill';
import Vue from 'vue';

import App from './components/App.vue';

const initVoteAd = (selector: string) => {
    Vue.config.productionTip = false;
    const mountEl = document.querySelector(selector) as any;

    const props = mountEl !== null ? { ...mountEl.dataset } : {};

    new Vue({
        el: mountEl,
        render: (createElement: any) => {
            const context = {
                props
            };

            return createElement(App, context);
        }
    });
}

if (typeof (window) !== 'undefined') {
    (window as any).initVoteAd = initVoteAd;
}

export default initVoteAd;
